<template>
  <div class="zpos-filter ">
    <ul class="nav nav-pills nav-fill panel mb-3">
      <li class="nav-item col-sm-6  offset-lg-1 col-lg-5 offset-xl-2 col-xl-4">
        <div class="nav-link"
             :class="{active: filter.type === 'byNum'}"
             @click="changeFilterType('byNum')">{{ $t("#TR-by-number") }}
        </div>
      </li>
      <li class="nav-item col-sm-6 col-lg-5 col-xl-4">
        <div class="nav-link"
             :class="{active: filter.type === 'byFilter'}"
             @click="changeFilterType('byFilter')">
          {{ $t("#TR-manual-search") }}
        </div>
      </li>
    </ul>

    <!--  byNum-->
    <div v-if="filter.type === 'byNum'"
         class="by-num">
      <div class="panel mb-3">
        <div class="row">
          <div class="col-sm-12 offset-md-2 col-md-8 offset-lg-3 col-lg-6">
            <div class="input-group">
              <input v-model="filter.byNum.zReportId"
                     type="number"
                     class="form-control">
              <div class="input-group-append">
                <button id="button-addon2"
                        class="btn btn-success"
                        type="button"
                        @click="onSubmitFilter">
                  <span class="mdi mdi-file-find"></span>
                  {{ $t("#TR-search") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  byfILTER-->
    <div v-if="filter.type === 'byFilter'"
         class="by-filter">
      <div class="panel mb-3">

        <div class="row mt-3 mb-3">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <label>{{ $t("#TR-start-date") }}</label>
            <b-form-input id="date-from"
                          v-model="filter.byFilter.from"
                          type="date">
            </b-form-input>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <label>{{ $t("#TR-end-date") }}</label>
            <b-form-input id="date-to"
                          v-model="filter.byFilter.to"
                          type="date">
            </b-form-input>
          </div>
        </div>


        <div class="row mb-3">
          <div class="col-sm-12 col-md-4 col-lg-3">
            <button class="btn btn-outline-success btn-block"
                    type="button"
                    @click="openRestCashGroupSelector">
              {{ $t("#TR-choose-restaurants-and-cash-stations") }}
            </button>
          </div>
          <div class="col-sm-12 col-md-8 col-lg-9">
            <div v-if="selected.restaurants.length > 0">
              <span class="font-weight-bolder small text-success">{{ $t("#TR-restaurants") }}:</span><br>
              <span v-for="rest in selected.restaurants"
                    :key="rest['guid']"
                    class="badge badge-secondary mr-1">{{ rest.name }}</span>
            </div>

            <div v-if="selected.cashGroups.length > 0">
              <span class="font-weight-bolder small text-success">{{ $t("#TR-cash-groups") }}:</span><br>
              <span v-for="cash in selected.cashGroups"
                    :key="cash['guid']"
                    class="badge badge-secondary mr-1">{{ cash.name }}</span>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="offset-sm-4 col-sm-5 offset-lg-5 col-lg-2">
            <button class="btn btn-success float-right btn-block"
                    type="button"
                    @click="onSubmitFilter">
              <span class="mdi mdi-file-find"></span>{{ $t("#TR-search") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <rest-cash-group-selector-modal ref="restCashGroupSelector"
                                    @onApplySelector="applyRestCashGroupSelector">
    </rest-cash-group-selector-modal>

  </div>
</template>

<script>
  import MSG from '@/services/notify';
  import RestCashGroupSelectorModal from '@/components/RestCashGroupSelector';

  export default {
    name: 'ZposFilter',
    components: {
      RestCashGroupSelectorModal
    },

    data() {
      return {
        selected: {
          restaurants: [],
          cashGroups: []
        },
        filter: {
          type: 'byNum',
          byNum: {
            zReportId: null
          },
          byFilter: {
            from: this.$moment({}).subtract(7, 'days').format('YYYY-MM-DD'),
            to: this.$moment({}).format('YYYY-MM-DD'),
            restaurants: [],
            cashGroups: []
          }
        }
      };
    },

    methods: {
      openRestCashGroupSelector() {
        this.$refs.restCashGroupSelector.onOpenSelector();
      },

      applyRestCashGroupSelector(selected) {
        this.selected.restaurants = selected.rests;
        this.selected.cashGroups = selected.cashGroups;
      },

      onSubmitFilter() {

        const error = this.validateFilter();
        if (error) {
          MSG.error(error, this);

          return;
        }

        this.filter.byFilter.restaurants = [];
        this.selected.restaurants.forEach((rest) => {
          this.filter.byFilter.restaurants.push(rest.guid);
        });

        this.filter.byFilter.cashGroups = [];
        this.selected.cashGroups.forEach((group) => {
          this.filter.byFilter.cashGroups.push(group.guid);
        });



        this.$emit('get-report', this.filter);
      },

      clearFilter() {

        this.selected = {
          restaurants: [],
          cashGroups: []
        };

        this.filter = {
          type: 'byNum',
          byNum: {
            zReportId: null
          },
          byFilter: {
            from: this.$moment({}).subtract(7, 'days').format('YYYY-MM-DD'),
            to: this.$moment({}).format('YYYY-MM-DD'),
            restaurants: [],
            cashGroups: []
          }
        };
      },

      validateFilter() {
        let error = null;
        switch (this.filter.type) {

          case 'byNum':
            if (this.filter.byNum.zReportId > 2147483647) {
              error = 'A very large number';
              this.filter.byNum.zReportId = null;
            }
            break;
          case 'byFilter':
            if (this.selected.restaurants.length < 1) {
              error = 'No restaurant selected';
            }
            if (this.selected.cashGroups.length < 1) {
              error = 'No cash station selected';
            }
            break;
        }

        return error;
      },

      changeFilterType(type) {
        this.filter.type = type;
        this.$emit('change-filter-type');
      }
    }
  };
</script>

<style lang="stylus" scoped>

.zpos-filter {
  .nav-link {
    text-transform: uppercase
    font-size: 14px
    background: md-grey-300
    color: md-grey-700
    cursor: pointer

    &:hover {
      /*color: md-grey-900 !important*/
    }

    &.active {
      background: c-accent
      color: md-white
    }
  }
}


.darkmode {
  .zpos-filter {
    .nav-link {
      background: c-dark-bg
      color: c-body-font-dark
      border: 1px solid c-dark-bg-light

      &.active {
        background: c-accent-dark
        color: c-body-font-dark
      }
    }
  }
}


</style>
